module.exports = __webpack_public_path__ + "static/media/EKDWXR3.5cd757d4.png";